/* eslint-disable react/jsx-pascal-case */
// base_info_view 1_1 
import React, { useState, useEffect } from 'react'
import BaseInfoView5_1 from './base_info_view_5_1'
import { Tabs, Badge, Checkbox, Button, Row, Col, Select } from './ot'
import {
    Eye,
    MousePointer,
    Loader2,
    TrendingUp,
    Edit, Share, Download,
} from "lucide-react"
import PagenationOt from '../utility/componentOt/views/PagenationOt';

const BaseInfoView5 = ({
    baseInfoView5_1props = {
        rowKey: "key",
        data: [
            {
                key: "1",
                baseCardView1_1Props: {
                    checked: false,
                    onCheckedChange: () => { }
                },
                baseCardView1_2Props: {
                    src: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRKFSgdhQvBlZO6I8s-jtKIYOED1NqEs4xEjA&s"
                },
                baseCardView1_3Props: {
                    value: "Facebook / 產品介紹 / 推薦文 / 精簡版",
                },
                baseCardView1_4Props: {
                    value: "元件項目：標題、主文內容、圖片、按鈕、Hashtag",
                },
                baseCardView1_5Props: {
                    stats: [
                        {
                            value: null,
                            label: "瀏覽次數",
                            backgroundColor: "bg-blue-50",
                            animationDuration: 2000,
                            animationDelay: 0,
                            icon: null
                        },
                        {
                            value: 45,
                            label: "撰寫文案",
                            backgroundColor: "bg-green-50",
                            animationDuration: 1500,
                            animationDelay: 200,
                            icon: null
                        },
                        {
                            value: 320,
                            label: "點擊次數",
                            backgroundColor: "bg-blue-50",
                            animationDuration: 2000,
                            animationDelay: 0,
                            icon: <MousePointer className="h-4 w-4 text-purple-500" />

                        },
                        {
                            value: 28,
                            label: "複製次數",
                            backgroundColor: "bg-green-50",
                            animationDuration: 1500,
                            animationDelay: 200,
                            icon: <TrendingUp className="h-4 w-4 text-orange-500" />

                        },
                    ]
                },
                baseCardView1_6Props: {
                    badges: [
                        {
                            label: "王小明",
                            variant: "outline",
                            className: ""
                        },
                        {
                            label: <><svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="12"
                                height="12"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            >
                                <rect width="18" height="18" x="3" y="3" rx="2" ry="2" />
                                <path d="M8 11h8" />
                                <path d="M8 15h8" />
                                <path d="M8 7h8" />
                            </svg>2025-05-30</>,
                            variant: "outline",
                            className: ""
                        },
                    ]
                },
                baseCardView1_7Props: {
                    children: <p className="text-gray-600 mt-1 text-sm">儲存位置12w23：.../.../...</p>
                },
                baseCardView1_8Props: {
                    buttons: [
                        <Button variant="outline" className="flex-1">
                            <Eye className="h-4 w-4 mr-1" />
                            查看
                        </Button>,
                        <Button className="flex-1">
                            <Edit className="h-4 w-4 mr-1" />
                            複製文案內容並編輯
                        </Button>,
                        <Button variant="ghost" size="sm">
                            <Share className="h-4 w-4 mr-1" />
                            分享
                        </Button>,
                        <Button variant="ghost" size="sm">
                            <Download className="h-4 w-4 mr-1" />
                            匯出
                        </Button>,
                        <Button variant="ghost" size="sm" className="text-red-600">
                            刪除
                        </Button>,
                    ],
                    buttonGroupsColumnsCount: [2, 3],
                },
            },
        ],
        onBaseCardView1CheckChange: () => { },
        baseCardView1ShowComponent: [
            "BaseCardView1_1",
            "BaseCardView1_2",
            "BaseCardView1_3",
            "BaseCardView1_4",
            "BaseCardView1_5",
            "BaseCardView1_6",
            "BaseCardView1_7",
            "BaseCardView1_8",
        ],

    },
    reload = false,
    request = () => {
        return new Promise((resolve, reject) => {
            resolve({
                data: [],
                total: 0,
            });
        });
    },
    reloadCount = 0,
    reloadAndResetCount = 0,
    pageSize = 10,
    searchCount = 0,
    getBaseCardViewData = (data) => { return data },
    showMode = "page",
    reloadParams, // 這個參數是為了讓父層可以傳入一些參數，當這些參數改變時，BaseInfoView5會重新請求資料。常見的用法是傳入selectedRowKeys，讓BaseInfoView5在選擇改變時重新請求資料。
    ...props
}) => {
    const [conponentData, setConponentData] = useState([])
    const [total, setTotal] = useState(0)
    const [loadingCount, setLoadingCount] = useState(0)
    const loading = loadingCount > 0
    const [pagination, setPagination] = useState({
        pageIndex: 0, //initial page index
        size: pageSize, //default page size
    });

    const startLoading = () => setLoadingCount(c => c + 1)
    const endLoading = () => setLoadingCount(c => Math.max(0, c - 1))


    const onPageChange = ({ cur_page, size }) => {
        startLoading();
        request({ cur_page, size })
            .then((response) => {
                if (!response) {
                    endLoading();
                    return;
                }
                if (showMode === "infiniteScroll") {
                    setConponentData((pre) => {
                        let newData = getBaseCardViewData(response?.data)
                        return [...pre, ...newData]
                    });
                    setTotal(response?.total || 0);
                }
                else {
                    let newData = getBaseCardViewData(response?.data)
                    setConponentData(newData);
                    setTotal(response?.total || 0);
                }
            })
            .catch(function () {
                setConponentData([]);
                setTotal(0);
            })
            .finally(() => {
                endLoading();
            });
    };

    // 初始載入
    useEffect(() => {
        startLoading();
        request({ cur_page: pagination?.pageIndex + 1, size: pagination?.size })
            .then((response) => {
                if (!response) {
                    endLoading();
                    return;
                }
                let newData = getBaseCardViewData(response?.data)
                setConponentData(newData);
                setTotal(response?.total || 0);
            })
            .catch(function (err) {
                console.error(err);
                setConponentData([]);
                setTotal(0);
            })
            .finally(() => {
                endLoading();
            });
        // eslint-disable-next-line
    }, [])

    // reloadAndResetCount
    useEffect(() => {
        if (reloadAndResetCount !== 0) {
            startLoading();
            setPagination((pre) => ({
                ...pre,
                pageIndex: 0,
                size: pageSize,
            }));
            request({ cur_page: 1, size: pageSize })
                .then((response) => {
                    if (!response) {
                        endLoading();
                        return;
                    }
                    let newData = getBaseCardViewData(response?.data)
                    setConponentData(newData);
                    setTotal(response?.total || 0);
                })
                .catch(function () {
                    setConponentData([]);
                    setTotal(0);
                })
                .finally(() => {
                    endLoading();
                });
        }
        // eslint-disable-next-line
    }, [reloadAndResetCount])

    // reloadCount
    useEffect(() => {
        if (reloadCount !== 0) {
            startLoading();
            request({ cur_page: pagination?.pageIndex + 1, size: pagination?.size })
                .then((response) => {
                    if (!response) {
                        endLoading();
                        return;
                    }
                    let newData = getBaseCardViewData(response?.data)
                    setConponentData(newData);
                    setTotal(response?.total || 0);
                })
                .catch(function () {
                    setConponentData([]);
                    setTotal(0);
                })
                .finally(() => {
                    endLoading();
                });
        }
        // eslint-disable-next-line
    }, [reloadCount])

    // reload (只重算資料，不請求)
    useEffect(() => {
        if (reload > 0) {
            setConponentData((pre) => {
                let newData = getBaseCardViewData(pre)
                return newData;
            })
        }
        // eslint-disable-next-line
    }, [reload])
    // reloadParams (只重算資料，不請求)
    useEffect(() => {
        setConponentData((pre) => {
            let newData = getBaseCardViewData(pre)
            return newData;
        })

        // eslint-disable-next-line
    }, [reloadParams])

    // searchCount
    useEffect(() => {
        if (searchCount !== 0) {
            startLoading();
            setPagination((pre) => ({
                ...pre,
                pageIndex: 0,
                size: pageSize,
            }));
            request({ cur_page: 1, size: pageSize })
                .then((response) => {
                    if (!response) {
                        endLoading();
                        return;
                    }
                    let newData = getBaseCardViewData(response?.data)
                    setConponentData(newData);
                    setTotal(response?.total || 0);
                })
                .catch(function () {
                    setConponentData([]);
                    setTotal(0);
                })
                .finally(() => {
                    endLoading();
                });
        }
        // eslint-disable-next-line
    }, [searchCount])
    
    return (
        <Row gutter={[8, 8]} >
            <Col span={24}>
                <Row
                    gutter={[4, 4]}
                    align={"middle"}
                    justify={"end"}
                >
                    <Col>
                        第{" "}
                        {pagination?.size *
                            pagination?.pageIndex +
                            1}
                        ~
                        {(pagination.pageIndex + 1) *
                            pagination.size <=
                            total
                            ? (pagination.pageIndex + 1) *
                            pagination.size
                            : total}{" "}
                        筆 / 總共 {total} 筆
                    </Col>
                    <Col>
                        <Row gutter={[2, 2]} align={"middle"} wrap={false}>
                            <Col>每頁</Col>
                            <Col>
                                <Select
                                    defaultValue={{
                                        label: `${pagination?.size}`,
                                        value: pagination?.size
                                    }}
                                    value={{
                                        label: pagination?.size,
                                        value: pagination?.size
                                    }}
                                    options={[
                                        {
                                            label: '10',
                                            value: 10
                                        },
                                        {
                                            label: '20',
                                            value: 20
                                        },
                                        {
                                            label: '30',
                                            value: 30
                                        },
                                        {
                                            label: '50',
                                            value: 50
                                        },
                                        {
                                            label: '100',
                                            value: 100
                                        },

                                    ]}
                                    onChange={(value) => {
                                        onPageChange({
                                            cur_page: 1,
                                            size: value,
                                        })
                                        setPagination((pre) => ({
                                            ...pre,
                                            pageIndex: 0,
                                            size: value
                                        }))
                                    }}
                                />
                            </Col>
                            <Col>筆</Col>
                        </Row>
                    </Col>
                    <Col>
                        <PagenationOt
                            pageIndex={pagination?.pageIndex}
                            pageCount={Math.ceil(total / pagination?.size)}
                            onChange={(currentIndex) => {
                                onPageChange({ cur_page: currentIndex + 1, size: pagination?.size, })
                                setPagination((pre) => ({
                                    ...pre,
                                    pageIndex: currentIndex
                                }))
                            }}
                        />
                    </Col>
                </Row>
            </Col>
            <Col span={24}>
                {
                    loading ? <div className="flex flex-col items-center gap-2">
                        <Loader2 className="h-8 w-8 animate-spin text-primary" />
                        <p>正在載入...</p>
                    </div> :
                        <BaseInfoView5_1
                            {...baseInfoView5_1props}
                            data={conponentData}
                            onBaseCardView1CheckChange={baseInfoView5_1props.onBaseCardView1CheckChange}
                        />
                }
            </Col>
        </Row>
    )
}
export default BaseInfoView5